import { render, staticRenderFns } from "./StudentCardsPanel.vue?vue&type=template&id=8db759ce&scoped=true&"
import script from "./StudentCardsPanel.vue?vue&type=script&lang=js&"
export * from "./StudentCardsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StudentCardsPanel.vue?vue&type=style&index=0&id=8db759ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db759ce",
  null
  
)

export default component.exports